module.exports = __webpack_public_path__ + "static/media/CFC.71eef4be.jfif";